import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withAuthenticator } from './aws-amplify-react/Auth/index';
import asyncComponent from './components/AsyncComponent';
const GoodStandingCertificate = asyncComponent(() => import('./letters/GoodStandingCertificate'));
const GoodStandingCertificateArabic = asyncComponent(() => import('./letters/GoodStandingCertificateArabic'));
const MedicalDirector = asyncComponent(() => import('./letters/MedicalDirector'));
const PartTimePractice = asyncComponent(() => import('./letters/PartTimePractice'));
const PreMaritalApproval = asyncComponent(() => import('./letters/PreMaritalApproval'));
const VisitingConsultant = asyncComponent(() => import('./letters/VisitingConsultantConditional'));
const VisitingConsultantConditional = asyncComponent(() => import('./letters/VisitingConsultantConditional'));
const RequestForRecognition = asyncComponent(() => import('./letters/RequestForRecognition'));
const VisitingConsultantLicense = asyncComponent(() => import('./letters/VisitingConsultantLicense'));
const Lmra = asyncComponent(() => import('./letters/Lmra'));
const licenseCard = asyncComponent(() => import('./letters/licenseCard'));
const RenewalReminder = asyncComponent(() => import('./email-templates/RenewalReminder'));
const SecondLicenseCard = asyncComponent(() => import('./letters/SecondLicenseCard'));
const QrcodeVerify = asyncComponent(() => import('./QrCode/QrcodeVerify'));
const AppPayments = asyncComponent(() => import('./appPayments/index'));

const ProfessionAddlServiceLicenseRenewal = asyncComponent(() => import('./pages/ProfessionAddlService/LicenseRenewal'));
const ProfessionAddlServiceOtherServices = asyncComponent(() => import('./pages/ProfessionAddlService/OtherServices'));
const ProfessionAddlServiceOtherServices1 = asyncComponent(() => import('./pages/ProfessionAddlService/Services'));
const ProfessionAddlServiceOtherServices2 = asyncComponent(() => import('./pages/ProfessionAddlService/Services'));
const ProfessionAddlServiceOtherServices3 = asyncComponent(() => import('./pages/ProfessionAddlService/Services'));
const ProfessionAddlServiceVisitingConsultant = asyncComponent(() => import('./pages/ProfessionAddlService/VisitingConsultant'));
const ProfessionAddlServiceReCategorization = asyncComponent(() => import('./pages/ProfessionAddlService/ReCategorization'));
const ProfessionApplicationMoreInfoUpdate = asyncComponent(() => import('./pages/ProfessionAddlService/ApplicationMoreInfoUpdate'));
const Facility = asyncComponent(() => import('./pages/Facility'));
const PaymentProcess = asyncComponent(() => import('./pages/PaymentProcess'));
const PaymentResult = asyncComponent(() => import('./pages/PaymentProcess/PaymentResult'));
const Invitation = asyncComponent(() => import('./pages/Invitation'));
const Dashboard = asyncComponent(() => import('./pages/Dashboard'));
const ProfessionDashboard = asyncComponent(() => import('./pages/Dashboard/profession-dashboard.js'));
const FacilityDashboard = asyncComponent(() => import('./pages/Dashboard/facility-dashboard.js'));
const Professional = asyncComponent(() => import('./pages/Profession'));
const ProfessionLicenseExamUpdate = asyncComponent(() => import('./pages/ProfessionAddlService/LicenseExamUpdate'));
const ApplicationExtraInfoUpdate = asyncComponent(() => import('./pages/ProfessionAddlService/ApplicationExtraInfoUpdate'));
const test = asyncComponent(() => import('./pages/test'));
const ManageProfile = asyncComponent(() => import('./pages/Dashboard/ManageProfile'));
const UpdateUserDetails = asyncComponent(() => import('./pages/Dashboard/ManageProfile/UpdateUserDetails'));
const CustomChangePassword = asyncComponent(() => import('./pages/Dashboard/ManageProfile/CustomChangePassword'));
const ProfessionAddlServiceGoodstanding=asyncComponent(()=>import('./pages/ProfessionAddlService/GoodStanding/index'));
const ProfessionAddlServiceCombinedServices=asyncComponent(()=>import('./pages/ProfessionAddlService/CombinedServices/index'));
const ProfessionAddlServicePharmacyManager=asyncComponent(()=>import('./pages/ProfessionAddlService/PharmacyManager/index'));
const ProfessionAddlServiceHajpermit=asyncComponent(()=>import('./pages/ProfessionAddlService/HajPermit/index'));
const ProfessionAddlServicePremaritalpermit=asyncComponent(()=>import('./pages/ProfessionAddlService/Premaritalpermit/index'));
const ProfessionAddlServiceRequestletters=asyncComponent(()=>import('./pages/ProfessionAddlService/Requestletters/index'));
const ProfessionAddlServiceUpdateinfo=asyncComponent(()=>import('./pages/ProfessionAddlService/Updateuserinfo/index'));
const ProfessionAddlServiceTelemedicine=asyncComponent(()=>import('./pages/ProfessionAddlService/Telemedicine/index'));
const ProfessionAddlServiceUpdatecpd=asyncComponent(()=>import('./pages/ProfessionAddlService/Updatecpd/index'));
const IssuesTask=asyncComponent(()=>import('./IssuesTask/IssuesTask'));
// const signupGuidelines=asyncComponent(()=>import('./signupGuidelines/signupGuidelines'));
class Routes extends React.Component {
  render() {
    // console.log("this.props", this.props);
    // console.log("this.state", this.state);
    return (
      <Switch>
        <Route exact path='/' component={Dashboard} />
        <Route exact path='/dashboard' component={Dashboard} />
        <Route exact path='/test' component={test} />
        <Route exact path='/dashboard/facility' component={FacilityDashboard} />
        <Route exact path='/dashboard/profession' component={ProfessionDashboard} />
        <Route exact path='/facility' component={Facility} />
        <Route exact path='/paymentcancel' component={PaymentResult} />
        <Route exact path='/paymentsuccess' component={PaymentResult} />
        <Route exact path='/paymentfailure' component={PaymentResult} />
        <Route exact path='/paymentprocess' component={PaymentProcess} />
         <Route exact path='/invitation' component={Invitation} />
        <Route exact path='/professional' component={Professional} props={this.props} />
        <Route exact path='/professional/renewal' component={ProfessionAddlServiceLicenseRenewal} />
        <Route exact path='/professional/others' component={ProfessionAddlServiceOtherServices} />
        <Route exact path='/professional/others/parttime' component={ProfessionAddlServiceOtherServices1} />
        <Route exact path='/professional/others/surgicalprocedure' component={ProfessionAddlServiceOtherServices2} />
        <Route exact path='/professional/others/transferlicense' component={ProfessionAddlServiceOtherServices3} />
        <Route exact path='/professional/visitingconsultant' component={ProfessionAddlServiceVisitingConsultant} />
        <Route exact path='/professional/recategorization' component={ProfessionAddlServiceReCategorization} />
        <Route exact path='/professional/exam' component={ProfessionLicenseExamUpdate} />
        <Route exact path='/professional/appupdate' component={ApplicationExtraInfoUpdate} />        
        <Route exact path='/professional/moreinfoupdate' component={ProfessionApplicationMoreInfoUpdate} />   
        <Route exact path='/dashboard/profile' component={ManageProfile} />
        {/* <Route exact path='/profile/updatedetails' component={UpdateUserDetails} />   */}
        <Route exact path='/profile/changepassword' component={CustomChangePassword} />  
        <Route exact path='/professional/goodstanding' component={ProfessionAddlServiceGoodstanding} />  
        <Route exact path='/professional/combinedservices' component={ProfessionAddlServiceCombinedServices} />
        <Route exact path='/professional/pharmacymanager' component={ProfessionAddlServicePharmacyManager} />
        <Route exact path='/professional/hajpermit' component={ProfessionAddlServiceHajpermit} />
        <Route exact path='/professional/premaritalpermit' component={ProfessionAddlServicePremaritalpermit} />
        <Route exact path='/professional/requestletters' component={ProfessionAddlServiceRequestletters} />
        <Route exact path='/professional/updatecontactinfo' component={ProfessionAddlServiceUpdateinfo} />
        <Route exact path='/professional/telemedicine' component={ProfessionAddlServiceTelemedicine} />
        <Route exact path='/professional/updatecpd' component={ProfessionAddlServiceUpdatecpd} />
        <Route exact path='/IssuesTask/IssuesTask' component={IssuesTask} />
        {/* <Route exact path='/signupGuidelines/signupGuidelines' component={signupGuidelines} /> */}
        

        {/* Done By Veerababu */}

        <Route exact path='/letters/GSC' component={GoodStandingCertificate} />
        <Route exact path='/letters/gscAr' component={GoodStandingCertificateArabic} />
        <Route exact path='/letters/medicaldirector' component={MedicalDirector} />
        <Route exact path='/letters/parttimepractice' component={PartTimePractice} />
        <Route exact path='/letters/premaritalapproval' component={PreMaritalApproval} />
        <Route exact path='/letters/visitingconsultant' component={VisitingConsultant} />
        <Route exact path='/letters/visitingconsultantConditonal' component={VisitingConsultantConditional} />
        <Route exact path='/letters/requestforrecognition' component={RequestForRecognition} />
        <Route exact path='/letters/visitingconsultantlicense' component={VisitingConsultantLicense} />
        <Route exact path='/letters/lmra' component={Lmra} />
        <Route exact path='/letters/licenseCard' component={licenseCard} />
        <Route exact path='/email-templates/RenewalReminder' component={RenewalReminder} />
        <Route exact path='/letters/SecondLicenseCard' component={SecondLicenseCard} />
        <Route exact path='/dashboard/profile/updatedetails' component={UpdateUserDetails} />
        <Route exact path='/QrCode/QrcodeVerify' component={QrcodeVerify} />

        <Route exact path='/app/paymentsuccess' component={AppPayments} />
        <Route exact path='/app/paymentcancel' component={AppPayments} />
        <Route exact path='/app/paymentfailure' component={AppPayments} />

        <Route render={function () {
          return <h1>Not Authorized</h1>;
          // <Route exact path='/dashboard/profession' component={ProfessionDashboard} />
          
        }} />
      </Switch>
    )
  }
};

export default (withAuthenticator)(Routes);